export enum enumVoyageStatus {
  DRAFT,
  PUBLISHED,
  LOADED,
  IN_TRANSIT,
  OPTIMIZING,
  OPTIMIZED,
  AT_ARRIVAL_PORT,
  AT_DESTINATION_WAREHOUSE,
  EXPIRED,
}
